export const vehicleHelper = type => {
  switch (type) {
    case 'car':
      return '汽車';
    case 'heavy_moto':
      return '大型重型機車';
    case 'moto':
      return '機車';
    case 'trailer':
      return '拖車';
    default:
      return '';
  }
};
